import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=37753538&"
import script from "./TextLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./TextLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=37753538&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports